export default __webpack_public_path__ + "static/media/health_checks_low.b4f52eb6.svg";